import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  accuracyContainer: {
    display: 'flex',
  },
}));

export default useStyles;
